import Vue from 'vue'

function update (mediaAssetId, data = {}) {
  return Vue.api.patch(`/media-assets/${mediaAssetId}/tags`, { data })
}

export default {
  update
}
